<div class="ui-g container coupons-container full-height" provide-parent-form *ngIf="coupons">
        <ng-container *ngFor="let coupon of coupons;let index=index;">
            <app-roulette-coupons-settings-item  [coupon]="coupon" [index]="index" [iconsList]="icons" [form]="form"></app-roulette-coupons-settings-item>
        </ng-container>
</div>